import { getOrganisationWithPartner } from '../../../graphql/queries';
import { API } from 'aws-amplify';


export async function FetchOrganizationWithPartnerOptions(partner: any) {
    return await API.graphql({ query: getOrganisationWithPartner, variables: {partner: partner}});
}
  